/**
 * محافظت از صفحه‌های حساب کاربری (پروفایل) در برابر کاربر مهمان.
 *
 * همه‌ی تب‌های پروفایل از یک شاخه‌ی `page_name === "auth"` در
 * `app/[[...slug]]/page.jsx` رد می‌شوند و فقط `seo.key` آن‌ها فرق می‌کند؛ این
 * لیست همان کلیدهاست. صفحه‌ی خود ورود (`auth`) عمداً در آن نیست.
 */
export const ACCOUNT_PAGE_KEYS = [
  "account-page",
  "information-page",
  "favorite-page",
  "comments-page",
  "addresses-page",
  "transactions-page",
  "orders-page",
];

export const is_account_page_key = (seo_key) => ACCOUNT_PAGE_KEYS.includes(seo_key);

/**
 * آدرس صفحه‌ی ورود با `?redirect-to=` تا بعد از ورود، کاربر به همان تبی که
 * خواسته بود برگردد (AuthFlow همین پارامتر را می‌خواند).
 */
export const build_login_url = (auth_path, return_path) => {
  const base = auth_path || "/auth/";
  if (!return_path) return base;
  // اسلش داخل query string مجاز است؛ باز نگهش می‌داریم تا آدرس به‌جای
  // `%2Faccount%2Forders%2F` خوانا بماند. بقیه‌ی کاراکترها (مثل ? و &) انکد
  // می‌مانند تا با پارامترهای خود صفحه‌ی ورود قاطی نشوند.
  return `${base}?redirect-to=${encodeURIComponent(return_path).replace(/%2F/gi, "/")}`;
};

// خروج از حساب در هدر و منوی پروفایل کاربر را به صفحه‌ی اصلی می‌برد. گارد
// کلاینتی پروفایل هم با false شدن is_auth به صفحه‌ی ورود هدایت می‌کند و چون
// دیرتر اجرا می‌شود، ناوبری خروج را خنثی می‌کرد. این پرچم می‌گوید این بار
// خروج عمدی بوده و مقصد را خود دکمه‌ی خروج تعیین کرده است.
let logout_navigation_pending = false;

export const mark_logout_navigation = () => {
  logout_navigation_pending = true;
  // فقط برای همین یک ناوبری معتبر است
  setTimeout(() => {
    logout_navigation_pending = false;
  }, 3000);
};

export const is_logout_navigation_pending = () => logout_navigation_pending;
